export class AoReportDeviceDetail {
  begin: string;
  end: string;
  site: string;
  position: string;
  com: string;
  duration: string;
  status: string;
  siteColor: string;
}
